module.exports = __webpack_public_path__ + "images/feature/move-3-efb8d3b78700b80c9a35c233499c9885.jpg";